import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Form } from 'react-final-form';

import {
    TextField,
    TextareaField,
    RadioButtonsField,
} from '/components/forms/components';

import { ValidationService, ApiService } from '/services';

const ActivityRegistration = ({ id, socialPricing }) => {
    const [message, setMessage] = useState('');

    const validate = values => {
        const rules = {
            firstName: 'required',
            lastName: 'required',
            email: 'required',
            phone: 'required',
            birthdate: 'required',
        };

        if (socialPricing) {
            rules.pricing = 'required';
        }

        const attributeNames = {
            firstName: 'voornaam',
            lastName: 'achternaam',
            email: 'e-mailadres',
            phone: 'telefoon',
            birthdate: 'geboortedatum',
            pricing: 'gratis lessen',
            remarks: 'opmerkingen',
        };

        const messages = {
            required: 'Het :attribute veld is verplicht.',
        };

        return ValidationService.validate(
            values,
            rules,
            attributeNames,
            messages,
        );
    };

    const submit = async values => {
        const data = {
            id,
            ...values,
        };

        const response = await ApiService.post(
            '/actions/modulosaurus/activity/register',
            data,
        );

        setMessage(response.message);
    };

    if (message) {
        return (
            <div className="text rich-text">
                <p className="lead">{message}</p>
            </div>
        );
    }

    /* eslint-disable-next-line */
    const render = ({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
            <TextField name="firstName" label="Voornaam" />
            <TextField name="lastName" label="Achternaam" />
            <TextField name="email" label="E-mailadres" type="email" />
            <TextField name="phone" label="Telefoon" type="tel" />
            <TextField name="birthdate" label="Geboortedatum" />
            {socialPricing && (
                <RadioButtonsField
                    name="pricing"
                    label="Gratis lessen"
                    options={[
                        {
                            value:
                                'Ik maak graag gebruik van de 5 gratis lessen.',
                            label:
                                'Ik maak graag gebruik van de 5 gratis lessen.',
                        },
                        {
                            value:
                                'Ik betaal het normaal tarief en schenk hierbij 5 gratis lessen aan iemand anders.',
                            label:
                                'Ik betaal het normaal tarief en schenk hierbij 5 gratis lessen aan iemand anders.',
                        },
                    ]}
                />
            )}
            <TextareaField name="remarks" label="Opmerkingen" />
            <div className="block is-medium with-medium-margin">
                <div className="form-actions">
                    <button className="button is-orange" type="submit">
                        Inschrijven
                    </button>
                </div>
            </div>
        </form>
    );

    return <Form validate={validate} onSubmit={submit} render={render} />;
};

ActivityRegistration.propTypes = {
    id: PropTypes.string.isRequired,
    socialPricing: PropTypes.bool,
};

ActivityRegistration.defaultProps = {
    socialPricing: false,
};

export { ActivityRegistration };
